import { useEffect, useMemo, useState } from "react";
import { IntlProvider } from "react-intl";
import {
  Route,
  RouterProvider,
  createHashRouter,
  createRoutesFromElements
} from "react-router-dom";
import "./App.css";
import Home from "./Home";
import Login from "./Login";
import Navbar from "./Navbar";
import Admin from "./admin/Admin.jsx";
import Blacklist from "./blacklist/Blacklist";
import AttributeOverview from "./category/AttributeOverview";
import ColorList from "./color/Color";
import EditColor from "./color/EditColor";
import Intro from "./components/Intro";
import { SnackProvider } from "./components/snackbar/SnackProvider";
import Data from "./data/DataOverview";
import ImageView from "./data/ImageView";
import { useLanguage } from "./hooks/useLanguage";
import Findit3d from "./import/Findit3d";
import ImportOverview from "./import/ImportOverview";
import EditManufacturer from "./manufacturer/EditManufacturer";
import Manufacturer from "./manufacturer/Manufacturer";
import EditMaterial from "./material/EditMaterial";
import Material from "./material/Material";
import EditModel from "./model/EditModel";
import Model from "./model/Model";
import EditObject from "./object/EditObject";
import ObjectOverview from "./object/ObjectOverview";
import Product from "./product/Product";
import ProductOverview from "./product/ProductOverview";
import { VERSION } from "./utils/lib.js";
import { createIntlInstance, intlErrorHandler } from "./utils/localesSetup";

function App() {
  const { locale } = useLanguage();
  const [messages, setMessages] = useState({});
  const [isLoading, setIsLoading] = useState(true);
  const [loggedIn, setLoggedIn] = useState(false);
  const [userInfo, setUserInfo] = useState(null);

  useEffect(() => {
    createIntlInstance(locale)
      .then(intl => {
        setMessages(intl.messages);
      })
      .catch(error => {
        console.log(error);
      });
  }, [locale]);

  const router = useMemo(() => {
    return createHashRouter(
      createRoutesFromElements(
        <Route path="/" element={<Navbar setLoggedIn={setLoggedIn} loggedIn={loggedIn} setUserInfo={setUserInfo} userInfo={userInfo} />}>
          <Route index element={<Home userInfo={userInfo} />} />
          <Route path="/manufacturers" element={<Manufacturer />} />
          <Route path="/manufacturer/:id" element={<EditManufacturer />} />
          <Route path="/products" element={<ProductOverview userInfo={userInfo} />} />
          <Route path="/product/:id" element={<Product userInfo={userInfo} />} />
          <Route path="/product/:pid/color/:id" element={<EditColor userInfo={userInfo} />} />
          <Route path="/product/:pid/material/:id" element={<EditMaterial userInfo={userInfo} />} />
          <Route path="/product/:pid/model/:id" element={<EditModel userInfo={userInfo} />} />
          <Route path="/colors" element={<ColorList userInfo={userInfo} />} />
          <Route path="/color/:id" element={<EditColor userInfo={userInfo} />} />
          <Route path="/materials" element={<Material userInfo={userInfo} />} />
          <Route path="/material/:id" element={<EditMaterial userInfo={userInfo} />} />
          <Route path="/models" element={<Model userInfo={userInfo} />} />
          <Route path="/model/:id" element={<EditModel userInfo={userInfo} />} />
          <Route path="/data" element={<Data userInfo={userInfo} />} />
          <Route path="/attributes" element={<AttributeOverview userInfo={userInfo} />} />
          <Route path="/login" element={<Login setLoggedIn={setLoggedIn} setUserInfo={setUserInfo} userInfo={userInfo} />} />
          <Route path="/image" element={<ImageView />} />
          <Route path="/objects" element={<ObjectOverview userInfo={userInfo} />} />
          <Route path="/object/:id" element={<EditObject userInfo={userInfo} />} />
          <Route path="/import" element={<ImportOverview userInfo={userInfo} />} />
          <Route path="/import/3dfindit" element={<Findit3d userInfo={userInfo} />} />
          <Route path="/blacklist" element={<Blacklist userInfo={userInfo} />} />
          <Route path="/admin" element={<Admin userInfo={userInfo} />} />
        </Route>
      )
    );
  }, [loggedIn, setLoggedIn]);

  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        minHeight: '100vh'
      }}
    >
      <main style={{ flex: 1 }} >
        <IntlProvider
          defaultLocale="de"
          locale={locale}
          messages={messages}
          onError={intlErrorHandler}
        >
          {isLoading && <Intro onEnd={() => setIsLoading(false)} />}
          <SnackProvider>
            <RouterProvider router={router} />
          </SnackProvider>
        </IntlProvider>
      </main>

      <div style={{
        backgroundColor: '#e3e3e3',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        paddingLeft: '5px',
        paddingRight: '5px'
      }} >
        <span>© 2013 - 2026 immersight GmbH</span>
        <p>v.{VERSION}</p>
      </div>
    </div>

  );
}

export default App;
